import * as yup from "yup";

import { FormId } from "../../../../components/enums";
import {
  emailValidatorRequired,
  nameSurnameValidatorRequired,
  phoneValidatorRequired,
  radioValidator,
} from "../../../../utilities/validators";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.APPLICANT]: yup.object({
    [ComponentId.APPLICANT_NAME]: nameSurnameValidatorRequired,
    [ComponentId.APPLICANT_SURNAME]: nameSurnameValidatorRequired,
    [ComponentId.APPLICANT_EMAIL]: emailValidatorRequired,
    [ComponentId.APPLICANT_PHONE]: phoneValidatorRequired("applicantphone"),
    [ComponentId.APPLICANT_IS_DRIVER]: radioValidator,
  }),
};
